import * as APPCONFIG from "../config/app-config.js";
import api from "./AuthAPI.js";
import Http from "./Http.js";

export const userBlockOrUnblock = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}user/userBlockOrUnblock`,
    data: formValues,
    headers: Http.AUTH_HEADERS()
  });
};


export const userApproveOrDeny = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}user/userApproveOrDeny`,
    data: JSON.stringify(formValues),
    headers: Http.AUTH_HEADERS()
  });
};

// export const getDoctorSpecialities = (formValues) => {
//   return api({
//     method: "post",
//     url: `${APPCONFIG.API_URL}doctor/getDoctorSpecialities`,
//     data: JSON.stringify(formValues),
//     headers: Http.AUTH_HEADERS()
//   });
// };

// export const getDoctorsList = (formValues) => {
//   return api({
//     method: "post",
//     url: `${APPCONFIG.API_URL}doctor/getDoctorsList`,
//     data: JSON.stringify(formValues),
//     headers: Http.AUTH_HEADERS()
//   });
// };


// export const doctorBlockOrUnblock = (formValues) => {
//   return api({
//     method: "post",
//     url: `${APPCONFIG.API_URL}doctor/userBlockOrUnblock`,
//     data: JSON.stringify(formValues),
//     headers: Http.AUTH_HEADERS()
//   });
// };